module.exports = __webpack_public_path__ + "static/1-3bc6a1afd3a830a46afa2ac047c1c88e.jpg";